import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';

import { RestaurantSlug, RestaurantStyle } from '../../../core/enums';
import { Restaurant, Review } from '../../../core/models';
import { ConfigService } from '../../../core/services/config.service';
import { MainService } from '../../../core/services/main.service';
import { CommonModule } from '@angular/common';
import { RestaurantAboutInstagramComponent } from './restaurant-about-instagram/restaurant-about-instagram.component';
import { RestaurantAboutImportantComponent } from './restaurant-about-important/restaurant-about-important.component';
import { RestaurantAboutPhotoInformationComponent } from './restaurant-about-photo-information/restaurant-about-photo-information.component';
import { RestaurantAboutMenuFavoritesComponent } from './restaurant-about-menu-favorites/restaurant-about-menu-favorites.component';

@Component({
    selector: 'app-restaurant-about',
    standalone: true,
    imports: [
        CommonModule,
        RestaurantAboutImportantComponent,
        RestaurantAboutInstagramComponent,
        RestaurantAboutPhotoInformationComponent,
        RestaurantAboutMenuFavoritesComponent
    ],
    templateUrl: './restaurant-about.component.html',
    styleUrls: ['./restaurant-about.component.css'],
})
export class RestaurantAboutComponent implements OnInit {

    RestaurantSlug = RestaurantSlug;
    RestaurantStyle = RestaurantStyle

    restaurant$: Observable<Restaurant>;
    reviews: Review[];

    constructor(
        private mainService: MainService,
        private route: ActivatedRoute,
        public configService: ConfigService
    ) { }

    ngOnInit() {
        this.restaurant$ = this.mainService.restaurantLoaded$;
        this.route.data.subscribe(res => this.reviews = res?.data ? res.data : []);
    }
}
